import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

const ChannelViewWindow = styled.img`
  width: ${574 * Screen.widthRatio}px;
    height: ${323 * Screen.widthRatio}px;
    position: relative;
    border-radius: ${20 * Screen.widthRatio}px;
}
`;

export default withImage(ChannelViewWindow);
